<template>
  <div v-if="visible" class="voice-banner" role="note">
    <button class="voice-banner-main" type="button" @click="open">
      <span class="voice-banner-dot" aria-hidden="true"></span>
      <span class="voice-banner-text">试试小雨超级语音：喊一声「小雨」，动嘴就能让 AI 帮你操作浏览器</span>
      <span class="voice-banner-go">去开启</span>
    </button>
    <button class="voice-banner-close" type="button" title="不再显示" aria-label="不再显示" @click="dismiss">×</button>
  </div>
</template>

<script>
import { showToast } from '@/utils/toast';

// 雨见浏览器里还没开小雨语音时,在 AI 面板和 a.yjllq.com 顶部推荐一下。
// 宿主 window.rainseeBrowser.voiceBanner 决定显不显示;点 × 回传宿主,以后不再出现。
const getBannerBridge = () => {
  const bridge = typeof window !== 'undefined' && window.rainseeBrowser && window.rainseeBrowser.voiceBanner;
  if (!bridge || typeof bridge.getState !== 'function' || typeof bridge.dismiss !== 'function') return null;
  return bridge;
};

export default {
  name: 'VoiceInviteBanner',
  data() {
    return { visible: false };
  },
  mounted() {
    if (!getBannerBridge()) return;
    this.refresh();
    // 在别处开了语音(引导页/右键菜单)后回到这里,推荐条跟着收起
    window.addEventListener('focus', this.refresh);
    document.addEventListener('visibilitychange', this.refresh);
  },
  destroyed() {
    window.removeEventListener('focus', this.refresh);
    document.removeEventListener('visibilitychange', this.refresh);
  },
  methods: {
    async refresh() {
      const bridge = getBannerBridge();
      if (!bridge || document.visibilityState === 'hidden') return;
      try {
        const state = await bridge.getState();
        this.visible = !!(state && state.show);
      } catch (e) {
        this.visible = false;
      }
    },
    open() {
      const bridge = getBannerBridge();
      if (bridge && typeof bridge.open === 'function') bridge.open().catch(() => {});
    },
    dismiss() {
      this.visible = false;
      const bridge = getBannerBridge();
      if (bridge) bridge.dismiss().catch(() => {});
      showToast('如果需要体验小雨超级语音，请右键 AI 图标', 'success', 4000);
    }
  }
};
</script>

<style scoped>
.voice-banner {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999999;
  display: flex;
  align-items: center;
  width: max-content;
  max-width: calc(100% - 16px);
  box-sizing: border-box;
  border: 1px solid #c7d7fe;
  border-radius: 10px;
  background: #eef3ff;
  color: #1e3a8a;
  box-shadow: 0 4px 14px rgba(30, 58, 138, 0.12);
  font-size: 13px;
  line-height: 18px;
}
.voice-banner-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 7px 4px 7px 12px;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.voice-banner-dot {
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3b6cf6;
}
.voice-banner-text {
  min-width: 0;
}
.voice-banner-go {
  flex: none;
  color: #2f5bea;
  font-weight: 600;
  white-space: nowrap;
}
.voice-banner-close {
  flex: none;
  width: 28px;
  height: 28px;
  margin-right: 4px;
  border: 0;
  border-radius: 6px;
  background: none;
  color: #64748b;
  font-size: 18px;
  line-height: 28px;
  cursor: pointer;
}
.voice-banner-close:hover {
  background: rgba(30, 58, 138, 0.08);
  color: #1e3a8a;
}
[data-theme="dark"] .voice-banner {
  border-color: #33427a;
  background: #1c2440;
  color: #dbe4ff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}
[data-theme="dark"] .voice-banner-go {
  color: #8fb0ff;
}
[data-theme="dark"] .voice-banner-close {
  color: #94a3b8;
}
[data-theme="dark"] .voice-banner-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #dbe4ff;
}
</style>
